import { generateClient } from "aws-amplify/api";
import {
  getProductByType,
  listProducts,
  getProduct,
  getProductByPlanId,
} from "../graphql/queries";

const client = generateClient();

const productService = {
  getProductByType: async (type) => {
    const response = await client.graphql({
      query: getProductByType,
      authMode: "apiKey",
      variables: { type },
    });
    return response;
  },
  listProducts: async (action) => {
    const response = await client.graphql({
      query: listProducts,
      authMode: "apiKey",
    });
    if (response.data?.listProducts?.items?.length > 0) {
      return response.data?.listProducts?.items;
    }
    return [];
  },
  getProductById: async (productId) => {
    const response = await client.graphql({
      query: getProduct,
      authMode: "apiKey",
      variables: { id: productId },
    });
    return response?.data?.getProduct || undefined;
  },
  getProductByPlanId: async (planId) => {
    const response = await client.graphql({
      query: getProductByPlanId,
      authMode: "apiKey",
      variables: { planId: planId },
    });
    return response?.data?.getProductByPlanId?.items[0] || undefined;
  },
  // getDefaultAppointment: async () => {
  //   const response = await client.graphql({
  //     query: getProductAppointment,
  //     authMode: 'API_KEY',
  //     variables: { id: defaultAppointmentID }
  //   });
  //   return response?.data?.getProductAppointment || undefined;
  // },
};

export default productService;
